import React from 'react';
import { BrowserRouter as Router, Route, StaticRouter } from 'react-router-dom';
import { QueryParamProvider, transformSearchStringJsonSafe, } from 'use-query-params';
import { isSSR } from '../helpers/ssr';
const queryStringifyOptions = {
    transformSearchString: transformSearchStringJsonSafe,
};
export function withQueryProvider(Component) {
    const OutputFunction = (props) => (React.createElement(React.Fragment, null, isSSR() ? (React.createElement(StaticRouter, null,
        React.createElement(QueryParamProvider, { ReactRouterRoute: Route, stringifyOptions: queryStringifyOptions },
            React.createElement(Component, { ...props })))) : (React.createElement(Router, null,
        React.createElement(QueryParamProvider, { ReactRouterRoute: Route, stringifyOptions: queryStringifyOptions },
            React.createElement(Component, { ...props }))))));
    return OutputFunction;
}
